module.exports = __webpack_public_path__ + "img/fwzt03_1.570ab3e.png";